document.addEventListener('DOMContentLoaded', function () {
  // Keep track of elements that already have event listeners
  const boundElements = new WeakSet();
  
  const observerCallback = () => {
    const cardBundlerATCButton = document.querySelector(".card-bundler-atc-button");
    const inputBoxes = document.querySelectorAll('.product-toggler-input input[type="checkbox"]');
    const qtyInput = document.querySelector(".price-per-item__container .quantity__input");
    const bundleNewPrice = document.querySelector(".bundle-price .new-price");
    const bundleOldPrice = document.querySelector(".bundle-price .old-price");
    const checkedInput = document.querySelector('input[data-variant-current-price]:checked');

    if (!cardBundlerATCButton || !qtyInput || !bundleNewPrice || !bundleOldPrice) return;

    // Initialize main product prices only once
    if (!cardBundlerATCButton.dataset.eventsBound) {
      let mainProductPrice = checkedInput
        ? +checkedInput.getAttribute('data-variant-current-price')
        : +cardBundlerATCButton.dataset.mainProductPrice;

      let mainProductOldPrice = checkedInput
        ? +checkedInput.getAttribute('data-variant-old-price')
        : +cardBundlerATCButton.dataset.mainProductOldPrice;

      cardBundlerATCButton.setAttribute("data-main-product-price", mainProductPrice);
      cardBundlerATCButton.setAttribute("data-main-product-old-price", mainProductOldPrice);

      if(checkedInput?.classList.contains("disabled")){
        cardBundlerATCButton.disabled = true;
        cardBundlerATCButton.querySelector(".atc-btn-text").textContent = "SOLD OUT";
      }

      cardBundlerATCButton.dataset.eventsBound = "true";
    }

    // Get current main product price (might change with variant selection)
    const mainProductPrice = +cardBundlerATCButton.dataset.mainProductPrice;
    const mainProductOldPrice = +cardBundlerATCButton.dataset.mainProductOldPrice;

    // Bind events to size option pills (including newly added ones)
    const sizeOptionPills = document.querySelectorAll("input[data-variant-current-price]");
    sizeOptionPills.forEach(optionPill => {
      if (!boundElements.has(optionPill)) {
        boundElements.add(optionPill);
        optionPill.addEventListener("click", function () {
          if (optionPill.checked && !optionPill.classList.contains("disabled")) {
            // console.log("Size option selected:", optionPill);

            if(cardBundlerATCButton.disabled == true){
              cardBundlerATCButton.disabled = false;
              cardBundlerATCButton.querySelector(".atc-btn-text").textContent = "ADD TO CART";
            }
            
            // Update main product prices when variant changes
            const newMainPrice = +optionPill.getAttribute('data-variant-current-price');
            const newMainOldPrice = +optionPill.getAttribute('data-variant-old-price');
            
            cardBundlerATCButton.setAttribute("data-main-product-price", newMainPrice);
            cardBundlerATCButton.setAttribute("data-main-product-old-price", newMainOldPrice);
            
            // Recalculate prices with new variant pricing
            const currentQty = +qtyInput.value;
            updatePricesFromQty(currentQty);
          }else{
            cardBundlerATCButton.disabled = true;
            cardBundlerATCButton.querySelector(".atc-btn-text").textContent = "SOLD OUT";
             // Update main product prices when variant changes
            const newMainPrice = +optionPill.getAttribute('data-variant-current-price');
            const newMainOldPrice = +optionPill.getAttribute('data-variant-old-price');
            
            cardBundlerATCButton.setAttribute("data-main-product-price", newMainPrice);
            cardBundlerATCButton.setAttribute("data-main-product-old-price", newMainOldPrice);
            
            // Recalculate prices with new variant pricing
            const currentQty = +qtyInput.value;
            updatePricesFromQty(currentQty);
          }
        });
      }
    });

    // Bind events to quantity input (only once)
    if (!boundElements.has(qtyInput)) {
      boundElements.add(qtyInput);
      qtyInput.addEventListener("change", function (e) {
        updatePricesFromQty(e.target.value);
      });
    }

    // Bind events to product toggle checkboxes (including newly added ones)
    inputBoxes.forEach(inputBox => {
      if (!boundElements.has(inputBox)) {
        boundElements.add(inputBox);
        inputBox.addEventListener("change", function () {
          const productId = this.getAttribute('data-product-id');
          const productPrice = +this.dataset.productPrice;
          const productOldPrice = +this.dataset.productOldPrice;

          let rawAttr = cardBundlerATCButton.getAttribute('data-complimentary-products') || "";
          let idArr = rawAttr.trim() === '' ? [] : rawAttr.trim().split(',');

          let bundleProductsTotalPrice = +cardBundlerATCButton.dataset.bundleProductsTotalPrice;
          let bundleProductsTotalOldPrice = +cardBundlerATCButton.dataset.bundleProductsTotalOldPrice;
          const mainProductsTotalPrice = +cardBundlerATCButton.dataset.mainProductsTotalPrice;
          const mainProductsTotalOldPrice = +cardBundlerATCButton.dataset.mainProductsTotalOldPrice;

          if (this.checked) {
            if (!idArr.includes(productId)) {
              idArr.push(productId);
              bundleProductsTotalPrice += productPrice;
              bundleProductsTotalOldPrice += productOldPrice;
            }
          } else {
            idArr = idArr.filter(id => id !== productId);
            bundleProductsTotalPrice -= productPrice;
            bundleProductsTotalOldPrice -= productOldPrice;
          }

          const totalBundleWithMainProdPrice = bundleProductsTotalPrice + mainProductsTotalPrice;
          const totalBundleWithMainProdOldPrice = bundleProductsTotalOldPrice + mainProductsTotalOldPrice;

          cardBundlerATCButton.setAttribute('data-complimentary-products', idArr.join(','));
          cardBundlerATCButton.setAttribute('data-bundle-products-total-price', bundleProductsTotalPrice);
          cardBundlerATCButton.setAttribute('data-bundle-products-total-old-price', bundleProductsTotalOldPrice);
          cardBundlerATCButton.setAttribute('data-total-bundle-price', totalBundleWithMainProdPrice);
          cardBundlerATCButton.setAttribute('data-total-bundle-old-price', totalBundleWithMainProdOldPrice);

          bundleNewPrice.innerHTML = formatCurrency(totalBundleWithMainProdPrice);
          bundleOldPrice.innerHTML = formatCurrency(totalBundleWithMainProdOldPrice);
        });
      }
    });

    // Initialize prices if not already done
    if (qtyInput.value && !cardBundlerATCButton.dataset.pricesInitialized) {
      updatePricesFromQty(qtyInput.value);
      cardBundlerATCButton.dataset.pricesInitialized = "true";
    }
  };

  // Currency formatting function
  function formatCurrency(amount) {
    const userCountry = window.Shopify?.country || 'AU';
    const currencyCode = window.Shopify?.currency?.active || 'AUD';
    const userLocale = navigator.language || 'en-AU';

    if (currencyCode === 'AUD') {
      return amount.toLocaleString('en-AU', {
        style: 'currency',
        currency: 'AUD',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    } else {
      return amount.toLocaleString(userLocale, {
        style: 'currency',
        currency: currencyCode,
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      });
    }
  }

  // Price update function
  function updatePricesFromQty(qty) {
    const cardBundlerATCButton = document.querySelector(".card-bundler-atc-button");
    const bundleNewPrice = document.querySelector(".bundle-price .new-price");
    const bundleOldPrice = document.querySelector(".bundle-price .old-price");
    
    if (!cardBundlerATCButton || !bundleNewPrice || !bundleOldPrice) return;

    const mainProdQty = +qty;
    const mainProductPrice = +cardBundlerATCButton.dataset.mainProductPrice;
    const mainProductOldPrice = +cardBundlerATCButton.dataset.mainProductOldPrice;
    const bundleProductsTotalPrice = +cardBundlerATCButton.dataset.bundleProductsTotalPrice || 0;
    const bundleProductsTotalOldPrice = +cardBundlerATCButton.dataset.bundleProductsTotalOldPrice || 0;
    
    const mainProductsPrice = mainProdQty * mainProductPrice;
    const mainProductsOldPrice = mainProdQty * mainProductOldPrice;
    const totalBundleWithMainProdPrice = mainProductsPrice + bundleProductsTotalPrice;
    const totalBundleWithMainProdOldPrice = mainProductsOldPrice + bundleProductsTotalOldPrice;

    cardBundlerATCButton.setAttribute('data-main-product-qty', mainProdQty);
    cardBundlerATCButton.setAttribute('data-main-products-total-price', mainProductsPrice);
    cardBundlerATCButton.setAttribute('data-main-products-total-old-price', mainProductsOldPrice);
    cardBundlerATCButton.setAttribute('data-total-bundle-price', totalBundleWithMainProdPrice);
    cardBundlerATCButton.setAttribute('data-total-bundle-old-price', totalBundleWithMainProdOldPrice);

    bundleNewPrice.innerHTML = formatCurrency(totalBundleWithMainProdPrice);
    bundleOldPrice.innerHTML = formatCurrency(totalBundleWithMainProdOldPrice);
  }

  // Run once initially in case everything is already on the page
  observerCallback();

  // Also run via MutationObserver when new DOM elements appear
  const observer = new MutationObserver(observerCallback);
  observer.observe(document.body, { childList: true, subtree: true });
});